// @flow

import React from 'react';
import { Grid, Typography, Tabs, Tab } from '@material-ui/core/';
import TabPanel from '../../../components/tabpanel';
import Cards from '../../../components/download/sdk/card';
import GetSdkContent from '../../../data/cms/content/download-sdk';
import './style.css';
import NoSearchResult from '../../../components/search/noresult-search';
import '../../../components/search/noresult-search/style.css';

function SDKs(props) {
    const [Scriptvalue, setScriptValue] = React.useState(0);
    const [GetSdk, setSdkContent] = React.useState({});
    const [SdkLoading, setSdkLoading] = React.useState(true);
    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedSDKContent = await GetSdkContent();
            setSdkContent(fetchedSDKContent);
            setSdkLoading(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
        fetchContent();
    }, []);

    const scriptHhandleChange = (event, newValue) => {
        setScriptValue(newValue);
    };
        return (
        <>
            {!SdkLoading ? (
                <Grid item xs={12} sm={12} md={12} lg={12} className="sdk">
                    {GetSdk.Download.Tabs.length >= 2 ? (
                        <Typography component="div" className="sdk-nav">
                            <Tabs
                                value={Scriptvalue}
                                onChange={scriptHhandleChange}
                                className="sdk-tabs"
                                variant="scrollable"
                            >
                                {GetSdk.Download.Tabs.length >= 2 ? (
                                    GetSdk.Download.Tabs
                                        .filter(Content => Content.Title.toLowerCase().includes(props.props.toLowerCase()))
                                        .map(
                                            (Content, index) => (
                                                <Tab
                                                    key={index}
                                                    label={Content.Title}
                                                />
                                            )
                                        )
                                ) : (
                                    <Tab label={GetSdk.Download.Tabs.Title} />
                                )}
                            </Tabs>
                        </Typography>
                    ) : (
                        ''
                    )}
                </Grid>
            ) : null}

            {!SdkLoading ? (
                GetSdk.Download.Tabs.length >= 2 ? (
                    GetSdk.Download.Tabs.map((tabContent, index) => (
                        <TabPanel key={index} value={Scriptvalue} index={index} >
                            <Grid container className="sdk-section">
                                <Grid container spacing={1}>
                                    {tabContent.Cards.Card.length >= 2 ? (
                                        tabContent.Cards.Card
                                            .filter(Content => Content.Title.toLowerCase().includes(props.props.toLowerCase()))
                                            .map(
                                                (Content, index) => (
                                                    <Cards
                                                        key={index}
                                                        Content={Content}
                                                    />
                                                )
                                            )
                                    ) : (
                                        props.props == '' ?
                                            <Cards
                                                Content={tabContent.Cards.Card}
                                            /> :
                                            tabContent.Cards.Card.Title.toLowerCase().includes(props.props.toLowerCase()) ?
                                                <Cards
                                                    Content={tabContent.Cards.Card}
                                                /> :
                                                <NoSearchResult />
                                    )}
                                </Grid>
                            </Grid>
                        </TabPanel>
                    ))
                ) : (
                    <Grid container className="sdk-section">
                        <Grid container spacing={1}>
                            {GetSdk.Download.Tabs.Cards.Card.length >= 2 ? (
                                GetSdk.Download.Tabs.Cards.Card
                                    .filter(Content => Content.Title.toLowerCase().includes(props.props.toLowerCase()))
                                    .map(
                                        (Content, index) => (
                                            <Cards key={index} Content={Content} />
                                        )
                                    )
                            ) : (
                                props.props == '' ? <Cards
                                    Content={GetSdk.Download.Tabs.Cards.Card}
                                /> :
                                    GetSdk.Download.Tabs.Cards.Card.Title.toLowerCase().includes(props.props.toLowerCase()) ?
                                        <Cards
                                            Content={GetSdk.Download.Tabs.Cards.Card}
                                        />
                                        : <NoSearchResult />
                            )}
                        </Grid>
                    </Grid>
                )
            ) : null}
        </>
    );
}
export default SDKs;
